import { ClassNames, CheckboxInput } from '@rocketmakers/armstrong-edge';
import * as React from 'react';
import { AppContext } from '../context/appProvider';
import { TechForGoodCategories, SupportCategories, getFriendlyCategoryName } from '../typings/data';

import chevronUp from '../assets/chevron-up.svg';
import chevronDown from '../assets/chevron-down.svg';

import './filterList.scss';

interface IProps {
  expandable?: boolean;
}

const FilterList: React.FC<IProps> = ({ expandable }) => {
  const { filterMode, filterCategories, setFilterCategories, resetFilterCategories } = React.useContext(AppContext);
  const [expanded, setExpanded] = React.useState(!expandable);

  React.useEffect(() => {
    if (expandable) {
      const removeFocus = () => setExpanded(false);
      window.addEventListener('click', removeFocus);

      return () => {
        window.removeEventListener('click', removeFocus);
      };
    }
  }, [expanded]);

  return (
    <div className="filters-wrapper" data-expandable={expandable} onClick={(e) => e.stopPropagation()}>
      {expandable && (
        <button onClick={() => setExpanded(!expanded)}>
          Filter companies
          <img alt="Chevron" src={expanded ? chevronUp : chevronDown} />
        </button>
      )}
      {expanded && (
        <div className="filters-list">
          {(filterMode === 'tech-for-good' ? TechForGoodCategories : SupportCategories)
            .slice()
            .sort()
            .map((c) => (
              <label key={c}>
                <div className={ClassNames.concat('icon-wrapper', c)}>
                  <div className="icon-inner">
                    <img alt={c} src={`/icons/${c}.svg`} />
                  </div>
                </div>
                <div className="filter-label">{getFriendlyCategoryName(c)}</div>
                <input
                  checked={filterCategories.indexOf(c) !== -1}
                  onChange={() => setFilterCategories(c)}
                  type="checkbox"
                />
              </label>
            ))}
          <button onClick={resetFilterCategories}>Clear filters</button>
        </div>
      )}
    </div>
  );
};

export default FilterList;
